module.exports = __webpack_public_path__ + "img/safe_tool_3.ffd9d86f.jpg";